<template>
  <el-table
    :border="true"
    id="rebateSetTable"
    :data="list"
    ref="table"
    show-summary
    :summary-method="getSummaries"
    :max-height="tableHeight"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.1)"
  >
    <el-table-column
      v-for="(item, i) in column"
      :prop="item.key"
      :label="item.name"
      :key="item.name"
      :sortable="item.sort"
      :sort-method="item.sortMethod"
      :fixed="item.fixed"
      align="center"
      :width="item.width"
    >
      <el-table-column
        :prop="item.key"
        :label="totalColumn[i] + ''"
        :width="
          item.key == 'totalIncre' || item.key == 'incomeTotalUSD' || item.key == 'popTotalUSD'
            ? 200
            : item.width
        "
        :key="item.name"
        align="center"
      >
        <template slot="header" slot-scope="scope">
          <span v-if="item.key == 'totalIncre'" style="display: flex; text-align: left">
            <span style="flex: 1">{{ totalColumn[i] }} </span>
            <span
              :style="{
                color:
                  Number(totalObj.totalIncre) < Number(totalColumn[i])
                    ? 'rgba(249, 29, 29, 1)'
                    : 'rgba(16, 204, 102, 1) ',
                flex: 1,
              }"
              >{{
                totalObj.totalIncre
                  ? (
                      (Math.abs(totalColumn[i] - totalObj.totalIncre) * 100) /
                      totalObj.totalIncre
                    ).toFixed(2) + "%"
                  : "-"
              }}

              <svg-icon v-if="totalObj.totalIncre < totalColumn[i]" iconClass="up"></svg-icon>
              <svg-icon v-else iconClass="down"></svg-icon>
            </span>
          </span>
          <span v-else-if="item.key == 'incomeTotalUSD'" style="display: flex; text-align: left">
            <span style="flex: 1">{{ totalColumn[i] }} </span>
            <span
              :style="{
                color:
                  Number(totalObj.totalIncome) <
                  Number(totalColumn[i] ? totalColumn[i].split('$')[1] : 0)
                    ? 'rgba(249, 29, 29, 1)'
                    : 'rgba(16, 204, 102, 1) ',
                flex: 1,
              }"
            >
              {{
                totalColumn[i] && totalObj.totalIncome
                  ? (
                      Math.abs(
                        (Number(totalColumn[i].split("$")[1]) - totalObj.totalIncome) * 100
                      ) / totalObj.totalIncome
                    ).toFixed(2) + "%"
                  : "-"
              }}

              <svg-icon
                v-if="
                  Number(totalObj.totalIncome) <
                  Number(totalColumn[i] ? totalColumn[i].split('$')[1] : 0)
                "
                iconClass="up"
              ></svg-icon>
              <svg-icon v-else iconClass="down"></svg-icon>
            </span>
          </span>
          <span v-else-if="item.key == 'popTotalUSD'" style="display: flex; text-align: left">
            <span style="flex: 1">{{ totalColumn[i] }} </span>
            <span
              :style="{
                color:
                  totalObj.totalPopu < Number(totalColumn[i] ? totalColumn[i].split('$')[1] : 0)
                    ? 'rgba(249, 29, 29, 1)'
                    : 'rgba(16, 204, 102, 1) ',
                flex: 1,
              }"
            >
              {{
                totalColumn[i] && totalObj.totalPopu
                  ? (
                      Math.abs((Number(totalColumn[i].split("$")[1]) - totalObj.totalPopu) * 100) /
                      totalObj.totalPopu
                    ).toFixed(2) + "%"
                  : "-"
              }}
              <svg-icon
                v-if="
                  totalObj.totalPopu < Number(totalColumn[i] ? totalColumn[i].split('$')[1] : 0)
                "
                iconClass="up"
              ></svg-icon>
              <svg-icon v-else iconClass="down"></svg-icon>
            </span>
          </span>
          <span v-else @click="handleS(scope)">{{ totalColumn[i] + "" }}</span>
        </template>
        <!-- <template  slot-scope="scope">
          <span>{{ scope.row["totalIncre"] }} 总</span>
        </template> -->
        <template slot-scope="scope">
          <span v-if="item.key == 'totalIncre'" class="zidingyi">
            <span class="zidingyileft"
              >{{ scope.row[item.key] ? item.unit : null
              }}{{ scope.row[item.key] ? scope.row[item.key] : "-"
              }}{{ scope.row[item.key] ? item.percent : null }}</span
            >
            <span
              class="zidingyiright"
              :class="{
                isGreen: scope.row['totalIncreDiffer'] && scope.row['totalIncreDiffer'] < 0,
                isRed: scope.row['totalIncreDiffer'] && scope.row['totalIncreDiffer'] > 0,
              }"
            >
              {{
                scope.row["totalIncreDiffer"] ? `${Math.abs(scope.row["totalIncreDiffer"])}%` : "-"
              }}

              <span v-if="!scope.row['totalIncreDiffer']" iconClass="up"></span>
              <svg-icon v-else-if="scope.row['totalIncreDiffer'] > 0" iconClass="up"></svg-icon>
              <svg-icon v-else iconClass="down"></svg-icon> </span
          ></span>
          <span v-else-if="item.key == 'incomeTotalUSD'" class="zidingyi">
            <span class="zidingyileft"
              >{{ scope.row[item.key] ? item.unit : null
              }}{{ scope.row[item.key] ? scope.row[item.key] : "-"
              }}{{ scope.row[item.key] ? item.percent : null }}</span
            >
            <span
              class="zidingyiright"
              :class="{
                isGreen: scope.row['totalIncomeDiffer'] && scope.row['totalIncomeDiffer'] < 0,
                isRed: scope.row['totalIncomeDiffer'] && scope.row['totalIncomeDiffer'] > 0,
              }"
            >
              {{
                scope.row["totalIncomeDiffer"]
                  ? `${Math.abs(scope.row["totalIncomeDiffer"])}%`
                  : "-"
              }}
              <span v-if="!scope.row['totalIncomeDiffer']" iconClass="up"></span>
              <svg-icon v-else-if="scope.row['totalIncomeDiffer'] > 0" iconClass="up"></svg-icon>
              <svg-icon v-else iconClass="down"></svg-icon> </span
          ></span>
          <span v-else-if="item.key == 'popTotalUSD'" class="zidingyi">
            <span class="zidingyileft"
              >{{ scope.row[item.key] ? item.unit : null
              }}{{ scope.row[item.key] ? scope.row[item.key] : "-"
              }}{{ scope.row[item.key] ? item.percent : null }}</span
            >
            <span
              class="zidingyiright"
              :class="{
                isGreen: scope.row['totalPopuDiffer'] && scope.row['totalPopuDiffer'] < 0,
                isRed: scope.row['totalPopuDiffer'] && scope.row['totalPopuDiffer'] > 0,
              }"
            >
              {{
                scope.row["totalPopuDiffer"] ? `${Math.abs(scope.row["totalPopuDiffer"])}%` : "-"
              }}
              <span v-if="!scope.row['totalPopuDiffer']" iconClass="up"></span>
              <svg-icon v-else-if="scope.row['totalPopuDiffer'] > 0" iconClass="up"></svg-icon>
              <svg-icon v-else iconClass="down"></svg-icon> </span
          ></span>
          <span v-else-if="item.key === 'lineCharts'">
            <div @click="openChartMoal(scope.row.incres || [], scope.row)">
              <cell-charts :dataList="scope.row.incres || []"></cell-charts>
            </div>
          </span>
          <span v-else
            >{{ scope.row[item.key] ? item.unit : null
            }}{{ scope.row[item.key] ? scope.row[item.key] : "-"
            }}{{ scope.row[item.key] ? item.percent : null }}</span
          >
        </template>
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
import XLSX from "xlsx";
import FileSaver from "file-saver";
import { sumArr } from "../../utils/tool";
import SvgIcon from "../../components/SvgIcon.vue";
import CellCharts from "./cellChart.vue";
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 280,
    };
  },
  computed: {
    totalObj: function () {
      return this.$store.state.Allreport.totalObj;
    },
  },
  components: { SvgIcon, CellCharts },
  props: {
    list: Array,
    column: Array,
    loading: Boolean,
    default_props: Object,
    totalColumn: Array,
  },
  methods: {
    downLoadFileToExcel() {
      this.$nextTick(() => {
        let fix = document.querySelector(".el-table__fixed");
        var xlsxParam = { raw: true }; //导出的内容只做解析，不进行格式转换(添加此行代码表格中的百分比就不会再导出的时候被转换成小数点)
        let wb;
        if (fix) {
          //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
          wb = XLSX.utils.table_to_book(
            document.querySelector("#rebateSetTable").removeChild(fix),
            xlsxParam
          );
          document.querySelector("#rebateSetTable").appendChild(fix);
        } else {
          wb = XLSX.utils.table_to_book(document.querySelector("#rebateSetTable"), xlsxParam);
        }

        let wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array",
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            "总览报表.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        // console.log(wbout);
        return wbout;
      });
    },

    getSummaries(param) {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        if (index === 1 || index === 2 || index === 3 || index === 4) {
          sums[index] = "-";
          return;
        }
        let unitArr = this.column.filter((v) => v.key == column.property);
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(unitArr[0].point);
          if (unitArr[0].unit) {
            sums[index] = unitArr[0].unit + sums[index];
          }
          // if (unitArr[0].percent) {
          //   sums[index] = sums[index] + unitArr[0].percent;
          // }
          if (unitArr[0].percent) {
            // console.log(sums[index]);
            data.length > 0 ? (sums[index] = Number(sums[index]) / data.length) : null;
            sums[index] = sums[index].toFixed(2);
            sums[index] = sums[index] + unitArr[0].percent;
          }
        } else {
          sums[index] = "-";
        }
      });
      try {
        const popTotalUSD = data.map((item) => Number(item["popTotalUSD"]));
        const incomeTotalUSD = data.map((item) => Number(item["incomeTotalUSD"]));
        const allTotalIncome = data.map((item) => Number(item["allTotalIncome"]));
        const totalIncre = data.map((item) => Number(item["totalIncre"]));
        let totalIncre1 = data.map((item) => Number(item["totalInstalls1"])),
          totalIncre3 = data.map((item) => Number(item["totalInstalls3"])),
          totalIncre7 = data.map((item) => Number(item["totalInstalls7"])),
          totalIncre14 = data.map((item) => Number(item["totalInstalls14"])),
          totalIncre30 = data.map((item) => Number(item["totalInstalls30"]));
        const retenRate1 = data.map((item) => Number(item["reten1"]));
        const retenRate3 = data.map((item) => Number(item["reten3"]));
        const retenRate7 = data.map((item) => Number(item["reten7"]));
        const retenRate14 = data.map((item) => Number(item["reten14"]));
        const retenRate30 = data.map((item) => Number(item["reten30"]));
        const orgIncre = data.map((item) => Number(item["orgIncre"]));
        const popuIncre = data.map((item) => Number(item["popuIncre"]));
        let retenRate1Total = sumArr(retenRate1);
        let retenRate3Total = sumArr(retenRate3);
        let retenRate7Total = sumArr(retenRate7);
        let retenRate14Total = sumArr(retenRate14);
        let retenRate30Total = sumArr(retenRate30);
        // const popuIncre = data.map((item) => Number(item["popuIncre"]));
        const activeUser = data.map((item) => Number(item["activeUser"]));
        let popTotalUSDTotal = sumArr(popTotalUSD);
        let totalIncreTotal = sumArr(totalIncre);
        let popuIncreTotal = sumArr(popuIncre);
        const totalOrgIncre = sumArr(orgIncre);
        sums[4] = totalIncreTotal ? totalIncreTotal : "-";
        sums[12] = totalIncreTotal ? "$" + (popTotalUSDTotal / totalIncreTotal).toFixed(2) : "-";
        sums[13] = popuIncreTotal ? "$" + (popTotalUSDTotal / popuIncreTotal).toFixed(2) : "-";
        sums[14] = sumArr(activeUser)
          ? "$" + (sumArr(incomeTotalUSD) / sumArr(activeUser)).toFixed(3)
          : "-";
        // sums[8] =
        //   sums[6] !== "0" && sums[6] !== "NaN" && sums[6] !== "-" && sums[6]
        //     ? ((sums[7] / sums[6]) * 100).toFixed(2) + "%"
        //     : "-";
        sums[9] = totalIncreTotal
          ? ((totalOrgIncre / totalIncreTotal) * 100).toFixed(2) + "%"
          : "-";
        sums[11] = totalIncreTotal ? (sumArr(activeUser) / totalIncreTotal).toFixed(2) : "-";
        // sums[10] =
        //   sums[5] !== "0" && sums[5] !== "NaN" && sums[5] !== "-" && sums[5]
        //     ? (sums[9] / sums[5]).toFixed(2)
        //     : "-";
        // sums[16] =
        //   ((sumArr(incomeTotalUSD) / sumArr(popTotalUSD)) * 100).toFixed(2) +
        //   "%";
        // let xingzengdanjia = popTotalUSDTotal / totalIncreTotal;
        // let arpu = sumArr(incomeTotalUSD) / sumArr(activeUser);
        // sums[16] =
        //   sumArr(incomeTotalUSD) && popTotalUSDTotal
        //     ? (
        //         (this.totalObj.totalEstimateTimes *
        //           sumArr(incomeTotalUSD) *
        //           totalIncreTotal) /
        //         (sumArr(activeUser) * popTotalUSDTotal)
        //       ).toFixed(2) + "%"
        //     : "-";
        sums[15] =
          sumArr(incomeTotalUSD) && popTotalUSDTotal
            ? (
                (this.totalObj.totalEstimateTimes /
                  (popTotalUSDTotal / totalIncreTotal).toFixed(2)) *
                100 *
                (sumArr(incomeTotalUSD) / sumArr(activeUser)).toFixed(3)
              ).toFixed(2) + "%"
            : "-";
        sums[16] = popTotalUSDTotal
          ? ((sumArr(allTotalIncome) / popTotalUSDTotal) * 100).toFixed(2) + "%"
          : "-";
        // sums[18] = popTotalUSDTotal
        //   ? ((sumArr(incomeTotalUSD) / popTotalUSDTotal) * 100).toFixed(2) + "%"
        //   : "-";
        sums[17] = this.totalObj.totalRoi + "%";
        sums[18] =
          isNaN(retenRate1Total) || retenRate1Total == 0
            ? "-"
            : ((retenRate1Total / sumArr(totalIncre1)) * 100).toFixed(2) + "%";
        sums[19] =
          isNaN(retenRate3Total) || retenRate3Total == 0
            ? "-"
            : ((retenRate3Total / sumArr(totalIncre3)) * 100).toFixed(2) + "%";
        sums[20] =
          isNaN(retenRate7Total) || retenRate7Total == 0
            ? "-"
            : ((retenRate7Total / sumArr(totalIncre7)) * 100).toFixed(2) + "%";
        sums[21] =
          isNaN(retenRate14Total) || retenRate14Total == 0
            ? "-"
            : ((retenRate14Total / sumArr(totalIncre14)) * 100).toFixed(2) + "%";
        sums[22] =
          isNaN(retenRate30Total) || retenRate30Total == 0
            ? "-"
            : ((retenRate30Total / sumArr(totalIncre30)) * 100).toFixed(2) + "%";
        // 内购收入占比 = 内购收入/(变现收入+内购收入)
        sums[23] = this.totalObj.totalPayPerAdsRate + "%"; // 内购收入占比（这个是后端算的）
      } catch (e) {
        throw new Error(e);
      }

      this.$emit("computTotalColumn", sums);
      return [];
    },
    refresh() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    handleS(scope) {
      console.log(scope);
    },
    openChartMoal(data, row) {
      if (data.length > 0) {
        this.$emit("openModal", data, row);
      }
    },
  },
  mounted() {
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.el-table {
  overflow: visible !important;
}

.isGreen {
  color: rgba(16, 204, 102, 1);
}
.isRed {
  color: rgba(249, 29, 29, 1);
}
.zidingyi {
  width: 100%;
  display: flex;

  .zidingyileft {
    flex: 1;
    text-align: left;
  }
  .zidingyiright {
    flex: 1;
    text-align: left;
    // margin-left: 3px;
  }
}
</style>
